import React from "react";

const DailyDigest = () => {
  return <div>DailyDigest</div>;
};

export default DailyDigest;
